<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">消息推送管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>消息类型与通道</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="toolbar">
        <el-select
          v-model="filterTenantId"
          class="filter-item"
          size="small"
          clearable
          placeholder="租户（空=平台）"
          style="width: 200px"
          @change="fetchList"
        >
          <el-option
            v-for="t in tenantOptions"
            :key="'t' + t.tenantId"
            :label="t.tenantName"
            :value="t.tenantId"
          />
        </el-select>
        <el-select
          v-model="filterMessageSource"
          class="filter-item"
          size="small"
          clearable
          filterable
          placeholder="消息类型"
          style="width: 240px"
          @change="fetchList"
        >
          <el-option
            v-for="m in messageSourceOptions"
            :key="m.code"
            :label="m.labelZh"
            :value="m.code"
          />
        </el-select>
        <el-button size="small" @click="onReset">重置</el-button>
        <el-button type="primary" size="small" @click="openCreate">新增绑定</el-button>
      </div>
      <el-table :data="rows" border size="small" style="width: 100%">
        <el-table-column label="序号" width="72">
          <template slot-scope="scope">
            {{ (page - 1) * pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="租户" min-width="140" prop="tenantName" />
        <el-table-column label="通道名称" min-width="100" prop="channelCode" show-overflow-tooltip />
        <el-table-column label="消息类型" min-width="160" prop="messageSourceLabelZh" />
        <el-table-column label="模版" min-width="160" show-overflow-tooltip prop="notifyTemplate" />
        <el-table-column label="通道" min-width="260">
          <template slot-scope="scope">
            <div>{{ scope.row.channelLabelZh }}</div>
            <div v-if="scope.row.msgUse" class="sub">{{ scope.row.msgUse }}</div>
          </template>
        </el-table-column>
        <el-table-column label="通知" width="88">
          <template slot-scope="scope">
            {{ scope.row.notifyType === 1 ? '内部' : '外部' }}
          </template>
        </el-table-column>
        <el-table-column label="启用" width="90">
          <template slot-scope="scope">
            <el-switch
              :value="bindingEnabledOn(scope.row)"
              active-color="#13ce66"
              @change="(v) => onBindingEnabledChange(scope.row, v)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
            <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color:#f56c6c" @click="confirmDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next, sizes"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="page"
        :page-sizes="[10, 20, 50]"
        @size-change="onSizeChange"
        @current-change="fetchList"
      />
    </el-card>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="620px"
      :close-on-click-modal="false"
      @closed="resetForm"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="formRules"
        label-width="120px"
        size="small"
        :disabled="isDetail"
      >
        <el-form-item label="租户" prop="tenantId">
          <el-select
            v-model="form.tenantId"
            placeholder="请选择"
            filterable
            style="width: 100%"
            :disabled="isDetail || isEdit"
            @change="onFormTenantChange"
          >
            <el-option
              v-for="t in tenantOptions"
              :key="'ft' + t.tenantId"
              :label="t.tenantName"
              :value="t.tenantId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="通道名称" prop="channelName">
          <el-select
            v-model="form.channelName"
            placeholder="通道种类，如飞书、邮件"
            filterable
            clearable
            style="width: 100%"
            :disabled="isDetail"
            @change="onChannelKindChange"
          >
            <el-option
              v-for="k in channelKindOptions"
              :key="'kind' + k.code"
              :label="k.labelZh"
              :value="k.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="消息类型" prop="messageSource">
          <el-select v-model="form.messageSource" placeholder="请选择" filterable style="width: 100%">
            <el-option
              v-for="m in messageSourceOptions"
              :key="'fm' + m.code"
              :label="m.labelZh"
              :value="m.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="通知类型" prop="notifyType">
          <el-select v-model="form.notifyType" placeholder="请选择" style="width: 100%">
            <el-option :value="0" label="外部（发送记录入库）" />
            <el-option :value="1" label="内部（不入库）" />
          </el-select>
        </el-form-item>
        <el-form-item label="消息通道" prop="channelId">
          <el-select
            v-model="form.channelId"
            clearable
            placeholder="选填，可不绑定具体通道实例"
            :placeholder="msgChannelPlaceholder"
            filterable
            style="width: 100%"
            :disabled="isDetail || msgChannelSelectDisabled"
          >
            <el-option v-for="c in channelPickOptions" :key="c.id" :label="c.displayLabel" :value="c.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="模版">
          <el-input
            v-model="form.notifyTemplate"
            type="textarea"
            :rows="3"
            maxlength="2048"
            show-word-limit
            placeholder="选填。通知类型=内部 时要填"
          />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.enabled" active-text="是" inactive-text="否" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="dialogVisible = false">{{ isDetail ? '关 闭' : '取消' }}</el-button>
        <el-button
          v-if="!isDetail"
          type="primary"
          size="small"
          :loading="submitLoading"
          @click="submitForm"
        >
          确定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from './api';

function emptyForm() {
  return {
    id: null,
    tenantId: null,
    channelName: '',
    messageSource: '',
    notifyType: 0,
    channelId: null,
    notifyTemplate: '',
    enabled: true,
  };
}

export default {
  name: 'MsgChannelSourceManage',
  data() {
    return {
      filterTenantId: null,
      filterMessageSource: '',
      tenantOptions: [],
      messageSourceOptions: [],
      channelKindOptions: [],
      channelPickOptions: [],
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      isDetail: false,
      form: emptyForm(),
      formRules: {
        tenantId: [{ required: true, message: '请选择租户', trigger: 'change' }],
        channelName: [{ required: true, message: '请选择通道名称', trigger: 'change' }],
        messageSource: [{ required: true, message: '请选择消息类型', trigger: 'change' }],
        notifyType: [
          {
            validator: (rule, value, callback) => {
              if (value !== 0 && value !== 1) {
                callback(new Error('请选择通知类型'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
      },
      submitLoading: false,
    };
  },
  created() {
    this.loadOptions();
    this.fetchList();
  },
  computed: {
    msgChannelSelectDisabled() {
      if (this.isDetail) return true;
      if (this.form.tenantId === null || this.form.tenantId === undefined) return true;
      const cn = this.form.channelName;
      return cn === null || cn === undefined || String(cn).trim() === '';
    },
    msgChannelPlaceholder() {
      if (this.isDetail) return '';
      if (!this.msgChannelSelectDisabled) return '选填，选同一通道种类下的具体记录或未选';
      return '请先选择租户与通道名称';
    },
  },
  methods: {
    bindPickerTenantId() {
      if (this.form.tenantId === undefined || this.form.tenantId === null) {
        return this.filterTenantId;
      }
      return this.form.tenantId;
    },
    async loadOptions() {
      try {
        const [tenants, sources, kinds] = await Promise.all([
          api.tenantOptions(),
          api.messageSourceOptions(),
          api.channelTypes(),
        ]);
        this.tenantOptions = (tenants && tenants.data) || [];
        this.messageSourceOptions = (sources && sources.data) || [];
        this.channelKindOptions = (kinds && kinds.data) || [];
      } catch (e) {
        /* empty */
      }
      await this.reloadChannelPickOptions();
    },
    async reloadChannelPickOptions() {
      if (!this.dialogVisible) {
        this.channelPickOptions = [];
        return;
      }
      const tid = this.bindPickerTenantId();
      if (tid === null || tid === undefined) {
        this.channelPickOptions = [];
        return;
      }
      const cn = this.form.channelName ? String(this.form.channelName).trim() : '';
      if (!cn) {
        this.channelPickOptions = [];
        return;
      }
      try {
        const res = await api.enabledChannels({ tenantId: tid, channelName: cn });
        this.channelPickOptions = (res && res.data) || [];
      } catch (e) {
        this.channelPickOptions = [];
      }
    },
    onFormTenantChange() {
      this.form.channelId = null;
      this.form.channelName = '';
      if (this.dialogVisible) {
        this.reloadChannelPickOptions();
      }
    },
    onChannelKindChange() {
      this.form.channelId = null;
      if (this.dialogVisible) {
        this.reloadChannelPickOptions();
      }
    },
    async fetchList() {
      try {
        const res = await api.page({
          page: this.page,
          size: this.pageSize,
          tenantId: this.filterTenantId,
          messageSource: this.filterMessageSource || undefined,
        });
        const pr = res && res.data ? res.data : {};
        this.rows = pr.items || [];
        this.total = pr.total || 0;
      } catch (e) {
        /* empty */
      }
    },
    onSizeChange(s) {
      this.pageSize = s;
      this.page = 1;
      this.fetchList();
    },
    onReset() {
      this.filterTenantId = null;
      this.filterMessageSource = '';
      this.page = 1;
      this.fetchList();
    },
    openCreate() {
      this.isDetail = false;
      this.isEdit = false;
      this.dialogTitle = '新增绑定';
      const f = emptyForm();
      f.tenantId =
        this.filterTenantId === null || this.filterTenantId === undefined || this.filterTenantId === ''
          ? 0
          : this.filterTenantId;
      this.form = f;
      this.dialogVisible = true;
      this.$nextTick(() => this.reloadChannelPickOptions());
    },
    openEdit(row) {
      this.isDetail = false;
      this.isEdit = true;
      this.dialogTitle = '编辑绑定';
      this.form = {
        id: row.id,
        tenantId: row.tenantId,
        channelName: row.channelCode || '',
        messageSource: row.messageSource,
        notifyType: row.notifyType != null ? row.notifyType : 0,
        channelId: row.channelId,
        notifyTemplate: row.notifyTemplate || '',
        enabled: row.enabled !== false && row.enabled !== 0,
      };
      this.dialogVisible = true;
      this.$nextTick(() => this.reloadChannelPickOptions());
    },
    async openDetail(row) {
      this.isDetail = true;
      this.isEdit = true;
      this.dialogTitle = '绑定详情';
      try {
        const tid =
          row.tenantId === undefined || row.tenantId === null || row.tenantId === '' ? 0 : row.tenantId;
        const res = await api.detail(row.id, tid);
        const d = res && res.data ? res.data : {};
        this.form = {
          id: d.id,
          tenantId: d.tenantId,
          channelName: d.channelCode || '',
          messageSource: d.messageSource,
          notifyType: d.notifyType != null ? d.notifyType : 0,
          channelId: d.channelId,
          notifyTemplate: d.notifyTemplate || '',
          enabled: d.enabled !== false && d.enabled !== 0,
        };
        this.dialogVisible = true;
        this.$nextTick(() => this.reloadChannelPickOptions());
      } catch (e) {
        this.isDetail = false;
      }
    },
    resetForm() {
      this.isDetail = false;
      this.form = emptyForm();
      this.submitLoading = false;
    },
    submitForm() {
      if (this.isDetail) return;
      this.$refs.form.validate(async (ok) => {
        if (!ok) return;
        this.submitLoading = true;
        try {
          const payload = {
            tenantId: this.form.tenantId,
            channelName: this.form.channelName,
            channelId: this.form.channelId,
            messageSource: this.form.messageSource,
            notifyType: this.form.notifyType,
            notifyTemplate: this.form.notifyTemplate || undefined,
            enabled: this.form.enabled,
          };
          if (this.isEdit) {
            payload.id = this.form.id;
            await api.update(payload);
          } else {
            await api.save(payload);
          }
          this.$message.success('保存成功');
          this.dialogVisible = false;
          this.fetchList();
        } catch (e) {
          /* empty */
        } finally {
          this.submitLoading = false;
        }
      });
    },
    confirmDelete(row) {
      this.$confirm('确认删除该绑定？', '提示', { type: 'warning' })
        .then(async () => {
          await api.remove(row.id, row.tenantId);
          this.$message.success('已删除');
          this.fetchList();
        })
        .catch(() => {});
    },
    bindingEnabledOn(row) {
      return row.enabled !== false && row.enabled !== 0;
    },
    async onBindingEnabledChange(row, v) {
      const tid =
        row.tenantId === undefined || row.tenantId === null || row.tenantId === '' ? 0 : row.tenantId;
      try {
        await api.setBindingEnabled(row.id, tid, v);
        row.enabled = v;
        this.$message.success('已更新');
      } catch (e) {
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style scoped>
.toolbar {
  margin-bottom: 12px;
}
.filter-item {
  margin-right: 8px;
}
.pager {
  margin-top: 12px;
  text-align: right;
}
.sub {
  color: #909399;
  font-size: 12px;
}
</style>
